import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../../../App'
import API from '../../../../services/API'
import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import MinorCrash from '@mui/icons-material/MinorCrash'

const AssignToVehicle = ({ drugBag, setView }) => {
  const [vehicleOptions, setVehicleOptions] = useState([])
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const { setToast } = useContext(GlobalContext)

  useEffect(() => {
    API.get('/vehicleList')
      .then((res) => res.status === 200 && setVehicleOptions(res.data))
      .catch(() => {
        setToast({
          message: 'Unable to load vehicles. Please try again later.',
          severity: 'error',
        })
      })
  }, [])

  const handleConfirm = () => {
    API.post('/medsmx/newlocation', {
      vehicle: selectedVehicle._id,
      id: drugBag._id,
    }).then((res) => {
      if (res.status === 200) {
        setView('home')
        setToast({ message: `Bag assigned to ${selectedVehicle.callSign}` })
      }
    })
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        backgroundColor: '#fff',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 2,
            display: 'grid',
            placeItems: 'center',
            color: '#0891B2',
            backgroundColor: '#0891B214',
          }}
        >
          <MinorCrash />
        </Box>

        <Stack spacing={0.5} textAlign="center">
          <Typography variant="h6" fontWeight={950}>
            Assign {drugBag.name} to a vehicle
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Select the vehicle carrying this medicine bag.
          </Typography>
        </Stack>

        <Autocomplete
          fullWidth
          value={selectedVehicle}
          options={vehicleOptions}
          renderInput={(params) => (
            <TextField {...params} size="small" label="Vehicle" fullWidth />
          )}
          getOptionKey={(opt) => opt._id}
          getOptionLabel={(opt) => opt.callSign}
          isOptionEqualToValue={(opt, val) => opt._id === val._id}
          onChange={(e, value) => setSelectedVehicle(value)}
        />

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} width="100%">
          <Button
            onClick={handleConfirm}
            disabled={!selectedVehicle}
            variant="contained"
            fullWidth
            sx={{
              borderRadius: 1.5,
              textTransform: 'none',
              fontWeight: 900,
              backgroundColor: '#1E7F88',
            }}
          >
            Assign to vehicle
          </Button>
          <Button
            onClick={() => setView('home')}
            variant="outlined"
            fullWidth
            sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 850 }}
          >
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default AssignToVehicle
